import { getHelpCenterBaseUrl } from "./getHelpCenterBaseUrl";

/**
 * Returns URL for users to submit a Help Center request
 */
export const getHelpCenterNewRequestUrl = (): string => `${getHelpCenterBaseUrl()}/requests/new`;
